<!--
 * @Author: ZhaoG
 * @Date: 2025-06-05 15:25:45
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-06 17:07:33
 * @FilePath: \gcp-fe\src\app\shop\views\viewNoticeSimpleDetailFB.vue
 * @Description: 分包详情
-->
<template>
  <div class="wrapper">
    <div style="display: flex; align-items: center;">
      <base-bread-crumb
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="false"
      ></base-bread-crumb>
    </div>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span
              >{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span
              >{{
                schemeObj.noticeStartTime
                  ? moment(schemeObj.noticeStartTime).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishUnit") }}：</span
              >{{ schemeObj.opUnitName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <div class="template-notice-detail-full">
        <div class="notice-detail-title">{{ noticeTypeName }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeTitle") }}：</span
            >
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeContent") }}：</span
            >
            <div class="notice-detail-li-con" v-html="pageData.textInfo"></div>
          </div>
        </div>
        <div class="notice-detail-title" style="padding-top: 40px">
          {{ $t("page.content.fileList") }}
        </div>
        <detailTable
          class="dic-sub-table-style01"
          :tableData="pageData.fileinfoBOS"
          :tableHead="fileHead"
          :showIndex="true"
        ></detailTable>

        <div class="notice-detail-title" style="padding-top: 40px">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable
          :tableData="relateNoticeList"
          :tableHead="noticeHead"
          :showIndex="true"
        >
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button
              size="mini"
              type="text"
              @click="handleNoticeTitleFB(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import { qryNoticeDetail, qryRelatedNoticeList } from "@/app/shop/api/shopping";
import moment from "moment";
import Cookies from "js-cookie";

export default {
  name: "viewNoticeSimpleDetailFB",
  components: {
    baseBreadCrumb,
    detailTable
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    }
  },
  mixins: [mixinHomePage],
  data() {
    return {
      moment,
      currBreadCrumb: [
        { title: "采购公告", path: "/procurementNotice" },
        { title: "中标结果公示", path: "/procurementNotice" }
      ],
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        {
          label: this.$t("page.content.fileSize"),
          prop: "fileSize",
          slot: "fileSize"
        },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center"
        }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        // {
        //   label: this.$t("page.content.link"),
        //   prop: "purStepName",
        //   width: 150
        // },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      // packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: "" //发布单位
      },
      noticeTypeName: "",
      type: this.$route.query.type,
      accessToken: ""
    };
  },
  activated() {
    this.accessToken = Cookies.get("access_token");
    this.currBreadCrumb[1].title =
      this.$route.query.noticeTypeName || "中标结果公示";
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  methods: {
    init() {
      // console.log(this.$route.query);
      // debugger;
      switch (this.type) {
        case "3":
          this.noticeTypeName = "补遗公告";
          // this.noticeTypeName = this.$t("page.content.labelMenu1");
          break;
        case "4":
          this.noticeTypeName = "评标结果公告";
          // this.noticeTypeName = this.$t("page.content.labelMenu5");
          break;
        case "5":
          this.noticeTypeName = "中标结果";
          break;
        case "7":
          this.noticeTypeName = this.$t("page.content.labelMenu3");
          break;
        case "8":
          this.noticeTypeName = this.$t("page.content.labelMenu2");
          break;
      }
      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        isLogin: this.loginInfo.name ? 1 : 0,
        noticeId: this.$route.query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.schemeName = this.pageData.schemeName;
          this.schemeObj.opUnitName = this.pageData.purchaseUnitName;
          this.schemeObj.schemeCode = this.pageData.schemeCode;
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
        }
      });

      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}
/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}
</style>
